module.exports = __webpack_public_path__ + "Icono_RecuperarContrasena_256px.png";